import axiosClient from "../../../utils/axios";
import { ApiResponse } from "../../../types/api.types";
import { GobalSettings } from "../types/settings.types";

export const getGobalSettings = async () => {
  try {
    const response =
      await axiosClient.get<ApiResponse<GobalSettings>>(`/settings`);
    return response.data;
  } catch (err) {
    console.warn("Error fetching Settings : ", err);
    throw err;
  }
};
